import { useCallback, useEffect, useRef } from 'react'

export const useScrollMouseWheel = (horizontal = false) => {
  const scrollContainer = useRef<HTMLDivElement>(null)
  const handleScroll = useCallback(
    (e: Event) => {
      const evt = e as WheelEvent
      evt.preventDefault()
      scrollContainer.current?.scrollBy(
        horizontal
          ? {
              left: evt.deltaY < 0 ? -30 : 30,
            }
          : { top: evt.deltaY < 0 ? -30 : 30 },
      )
    },
    [horizontal],
  )
  useEffect(() => {
    const newScrollContainer = scrollContainer.current
    newScrollContainer?.addEventListener('wheel', (e) => handleScroll(e), {
      passive: true,
    })

    return () => newScrollContainer?.removeEventListener('wheel', handleScroll)
  }, [handleScroll])

  return { scrollContainer }
}
